<div class="home__herobanner__container" *ngIf="loading">
  <div class="placeholder">{{ 'home.banner.loading' | translate }}</div>
</div>

<div class="home__herobanner__container" *ngIf="!loading && error">
  <app-section-error [message]="error" (retry)="loadBanners()"></app-section-error>
</div>

<div class="home__herobanner__container" *ngIf="!loading && !error && (!primarySlides || !primarySlides.length)">
  <div class="placeholder">{{ 'home.banner.no_data' | translate }}</div>
</div>

<div
  class="home__herobanner__bento"
  [class.has-side-banners]="sideSlides.length > 0"
  *ngIf="!loading && !error && primarySlides && primarySlides.length"
>
  <!-- Left Primary Banner (Banner 1, or slider if 4+ banners) -->
  <div class="bento-primary">
    <div class="slides" [style.transform]="'translateX(-' + index * 100 + '%)'">
      <div class="slide" *ngFor="let slide of primarySlides; let i = index">
        <div
          class="banner-wrapper"
          (click)="onSlideClick(slide.item)"
          role="link"
          tabindex="0"
          (keydown.enter)="onSlideClick(slide.item)"
        >
          <picture>
            <source media="(max-width: 768px)" [srcset]="slide.mobile">
            <img
              [src]="slide.desktop"
              [alt]="slide.item.title || ('home.banner.img_alt' | translate: { val: i + 1 })"
              [title]="slide.item.title || ('home.banner.img_alt' | translate: { val: i + 1 })"
            />
          </picture>
        </div>
      </div>
    </div>

    <ng-container *ngIf="primarySlides.length > 0">
      <button type="button" class="slide-btn prev" (click)="prevSlide()" aria-label="Previous slide">
        <span class="material-icons" aria-hidden="true">chevron_left</span>
      </button>
      <button type="button" class="slide-btn next" (click)="nextSlide()" aria-label="Next slide">
        <span class="material-icons" aria-hidden="true">chevron_right</span>
      </button>

      <div class="slide-dots">
        <button
          *ngFor="let slide of primarySlides; let i = index"
          type="button"
          class="slide-dot"
          [class.active]="i === index"
          (click)="showSlide(i)"
          [attr.aria-label]="'Slide ' + (i + 1)"
        ></button>
      </div>
    </ng-container>
  </div>

  <!-- Right Stacked Sub-Banners (Banner 2 & Banner 3) -->
  <div class="bento-side" *ngIf="sideSlides.length > 0" [class.is-single]="sideSlides.length === 1">
    <div
      class="bento-side__card"
      *ngFor="let side of sideSlides; let j = index"
      (click)="onSlideClick(side.item)"
      role="link"
      tabindex="0"
      (keydown.enter)="onSlideClick(side.item)"
    >
      <picture>
        <source media="(max-width: 768px)" [srcset]="side.mobile">
        <img
          [src]="side.desktop"
          [alt]="side.item.title || ('home.banner.img_alt' | translate: { val: j + 2 })"
          [title]="side.item.title || ('home.banner.img_alt' | translate: { val: j + 2 })"
        />
      </picture>
    </div>
  </div>
</div>